<template>
    <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
            <v-btn dark text color="blue-grey accent-4" v-on="on">
                회원가입
            </v-btn>
        </template>
        <v-card max-width="500" class="mx-auto">
            <v-card-title class="my-5">
                <h4 class="title blue-grey--text text--accent-4">회원가입</h4>
            </v-card-title>
            <v-card-text>
                <v-form v-model="valid" ref="form">
                    <v-text-field
                        type="email"
                        v-model="email"
                        label="이메일"
                        hint="ex) pingpong@pingpong.com"
                        :rules="emailRules"
                        required>
                    </v-text-field>
                    <v-text-field
                        type="password"
                        v-model="password"
                        label="비밀번호"
                        :rules="passwordRules"
                        required>
                    </v-text-field>
                    <v-text-field
                        v-model="user.name"
                        label="이름"
                        :rules="nameRules"
                        hint="ex) 홍길동"
                        required>
                    </v-text-field>
                    <v-text-field
                        v-model="user.alias"
                        label="별명"
                        :rules="aliasRules"
                        hint="ex) 날으는 돈까스"
                        required>
                    </v-text-field>
                    <p class="text-center caption pink--text" v-if="feedback">{{ feedback }}</p>
                    <v-select
                        v-model="user.level"
                        label="부수"
                        :items="levels">                        
                    </v-select>
                    <v-select
                        v-model="user.type"
                        label="유형"
                        :items="types">                        
                    </v-select>
                    <v-row justify="center">
                        <v-btn :loading="loading" class="mt-5 white--text" color="blue-grey accent-4" @click="signup" :disabled="!valid">제출하기</v-btn>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
  
</template>

<script>
import slugify from 'slugify'
import db from '@/fb'
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  name: 'Signup',
  data: () => ({
    dialog: false,
    loading: false,
    valid: false,
    feedback: null,
    email: '',
    emailRules: [
        v => !!v || '이메일은 꼭 필요해요!',
        v => /.+@.+/.test(v) || '제대로 된 이메일 주소를 입력해 주세요!',
    ],
    password: '',
    passwordRules: [
        v => !!v || '비밀번호는 꼭 필요해요!',
        v => v.length >= 8 || '8자는 넘어야 해요!'
    ],
    nameRules: [
        v => !!v || '이름은 꼭 필요해요!'
    ],
    aliasRules: [
        v => !!v || '별명은 꼭 필요해요!'
    ],
    user: {
        alias: null,
        level: null,
        name: null,
        type: null
    },
    openGroup: null,
    slug: null,
    levelRating: [
        // { level: 0, ratingMin: 1900, ratingMax: 3000 },
        // { level: 1, ratingMin: 1840, ratingMax: 1899 },
        // { level: 2, ratingMin: 1780, ratingMax: 1839 },
        // { level: 3, ratingMin: 1720, ratingMax: 1779 },
        // { level: 4, ratingMin: 1640, ratingMax: 1719 },
        // { level: 5, ratingMin: 1500, ratingMax: 1639 },
        // { level: 6, ratingMin: 1300, ratingMax: 1499 },
        // { level: 7, ratingMin: 1100, ratingMax: 1299 },
        // { level: 8, ratingMin: 900, ratingMax: 1099 },
        // { level: 9, ratingMin: 800, ratingMax: 899 },
        // { level: 10, ratingMin: 700, ratingMax: 799 }
        { level: 0, ratingMin: 1900, ratingMedium: 2500, ratingMax: 3000 },
        { level: 1, ratingMin: 1840, ratingMedium: 1870, ratingMax: 1899 },
        { level: 2, ratingMin: 1780, ratingMedium: 1810, ratingMax: 1839 },
        { level: 3, ratingMin: 1720, ratingMedium: 1750, ratingMax: 1779 },
        { level: 4, ratingMin: 1640, ratingMedium: 1680, ratingMax: 1719 },
        { level: 5, ratingMin: 1500, ratingMedium: 1570, ratingMax: 1639 },
        { level: 6, ratingMin: 1300, ratingMedium: 1400, ratingMax: 1499 },
        { level: 7, ratingMin: 1100, ratingMedium: 1200, ratingMax: 1299 },
        { level: 8, ratingMin: 900, ratingMedium: 1000, ratingMax: 1099 },
        { level: 9, ratingMin: 800, ratingMedium: 850, ratingMax: 899 },
        { level: 10, ratingMin: 700, ratingMedium: 750, ratingMax: 799 }
    ],
    levels: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    types: ['펜홀더', '쉐이크 핸즈', '중펜', '기타']
  }),
    methods: {
        signup() {
            this.loading = true;
            if(this.$refs.form.validate()){
                this.slug = slugify(this.user.alias, {
                    replacement: '-',
                    remove: /[$*_+~.()'"!\-:@]/g,
                    lower: true
                })

                let ref = db.collection('users').doc(this.slug)
                ref.get().then(doc => {
                    if(doc.exists){
                        this.feedback = "이 별명은 다른 사람이 먼저 쓰고 있어요!";
                    } else {
                        
                        // give the member total points accroding to the level
                        let total = this.giveTotalPoints(this.user.level);

                        // create a new user in db
                        firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
                            .then(cred => {
                                ref.set({
                                    name: this.user.name,
                                    type: this.user.type,
                                    alias: this.user.alias,
                                    level: parseInt(this.user.level),
                                    total: parseInt(total),
                                    wins: 0,
                                    loses: 0,
                                    avatar: '/avatar.png',
                                    user_id: cred.user.uid,
                                    joinedGroups: [],
                                    inGame: false,
                                    history: [parseInt(total)]
                                }).then(() => {
                                    this.dialog = false;
                                    this.loading = false;

                                    // push the user into the Open League db
                                    let members = this.openGroup.members;
                                    members.unshift({
                                        alias: this.user.alias,
                                        name: this.user.name,
                                        timeStamp : Date.now()
                                    })

                                    db.collection('groups').doc('open-league').update({
                                        members: members
                                    })
                                }).then(() => {
                                    location.reload();
                                })
                            }).catch(err => {
                                this.feedback = err.message
                            })
                    }
                })
            }            
        },
        giveTotalPoints(level){
            let total = null;
            this.levelRating.forEach(item => {
                if(level == item.level){
                    total = item.ratingMedium;
                }
            })
            return total;
        }
    },
    created(){
        db.collection('groups').doc('open-league').get().then(doc => {
            this.openGroup = doc.data();
        })
    }
};
</script>